import { getContractsDetail, getItemsDetail, getTokenList } from "@/api/nft";
import * as React from "react";
import { NFTEmpty } from "../empty";
import { Header } from "./components/header";
import { NFTItem, Skeleton } from "./components/item";
import { ProfileNFTGrid } from "./components/list";

interface IProps {
  userId: string;
}

const MAX_COUNT = 6;
const ProfileNftListPreview: React.FC<IProps> = ({ userId }) => {
  const [isLoading, setLoadStatus] = React.useState(false);

  const [nfts, setNfts] = React.useState<Moim.NFT.INftDetail[]>(undefined);
  const [contracts, setContracts] = React.useState<Moim.NFT.IContract[]>([]);
  const userTokens = nfts;
  const initialLoaded = userTokens !== undefined && !isLoading;

  const getNfts = React.useCallback(async () => {
    setLoadStatus(true);
    const userTokenList = await getTokenList(userId);
    const userTokenDetailList = await getItemsDetail(
      userTokenList.map(token => token.id),
    );
    setNfts(userTokenDetailList);
    const contractsData = await getContractsDetail(
      userTokenDetailList.map(token => {
        return token.contractId;
      }),
    );
    setContracts(contractsData);
    setLoadStatus(false);
  }, [userId]);

  React.useEffect(() => {
    getNfts();
  }, [userId]);

  const itemElements = React.useMemo(() => {
    if (!initialLoaded) {
      return (
        <ProfileNFTGrid>
          {new Array(3).fill(0).map((_, idx) => (
            <Skeleton key={idx} />
          ))}
        </ProfileNFTGrid>
      );
    }

    if (userTokens?.length === 0) {
      return <NFTEmpty />;
    }

    return (
      <ProfileNFTGrid>
        {userTokens?.slice(0, MAX_COUNT).map(token => (
          <NFTItem
            key={token.id}
            id={token.id}
            name={token.name}
            image={
              token.itemUrl?.startsWith("<svg")
                ? token.itemUrl
                : token.itemPreviewUrl
            }
            contract={contracts.find(contract => {
              return contract.id === token.contractId;
            })}
          />
        ))}
      </ProfileNFTGrid>
    );
  }, [contracts, initialLoaded, userTokens]);

  return (
    <>
      <Header userId={userId} hasNFT={(userTokens.length ?? 0) > 0} />

      {itemElements}
    </>
  );
};

export default React.memo(ProfileNftListPreview);
